import { ActionTree } from 'vuex'

import { ItemState, RootState } from '@/types/store'
import { IItem, ItemType } from '@/types/receipt'
import { ItemParams } from '@/types/item'

import { getNewItems, getReItems, putItem } from '@/api/items'

export const actions: ActionTree<ItemState, RootState> = {
  async getNewItems({ commit }, params: ItemParams): Promise<void> {
    commit('itemsLoaded', [])
    commit('itemsLoadStart', true)
    const items = await getNewItems(params)
    commit('itemsLoaded', items)
  },
  async renewNewItems({ commit }, params: ItemParams): Promise<void> {
    const items = await getNewItems(params)
    commit('itemsRenewed', items)
  },
  async getReItems({ commit }, params: ItemParams): Promise<void> {
    commit('itemsLoaded', [])
    commit('itemsLoadStart', true)
    const items = await getReItems(params)
    commit('itemsLoaded', items)
  },
  async resetItems({ commit }): Promise<void> {
    commit('itemsLoaded', [])
  },
  // async renewReItems({ commit }, limit = 50): Promise<void> {
  //   const items = await getReItems(limit)
  //   commit('itemsRenewed', items)
  // },
  setItemType({ commit }, itemType: ItemType): void {
    commit('setItemType', itemType)
  },
  async putItem(_, item: IItem): Promise<IItem> {
    return await putItem(item)
  },
  hideItem({ commit }, item: IItem): void {
    commit('hideItem', item)
  },
}
